import { createFileRoute } from '@tanstack/react-router';
import { fetchCompanyChainGraph } from '@/api/supply-chain-mapping';
import { SupplyChainDiagram } from '@/app/(client)/supply-chain-mapping/-components/SupplyChainDiagram';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/',
)({
  loader: ({ params }) =>
    // Best-effort prefetch — if the endpoint fails, the component still
    // re-runs the query via useQuery and shows its own error UI.
    queryClient
      .ensureQueryData({
        queryKey: ['supplyChainMapping', 'graph', params.id],
        queryFn: () => fetchCompanyChainGraph(params.id),
        staleTime: 60_000,
      })
      .catch(() => undefined),
  component: SupplyChainDiagram,
});
